export const scrollToView = (elementId) => {
    if (!elementId) return;

    console.log('SCROLL TO VIEW: ', elementId);

    const element = document.getElementById(elementId);
    if (element) {
        element.scrollIntoView({
            behavior: "smooth",
            block: "start",     
        });
    }
};
